// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradient-blue-30[data-v-b795de40] {\n  background: linear-gradient(30deg, #0e0d4b 35%, #26c6da 100%);\n}\n.text-red[data-v-b795de40] {\n  color: #ff0000;\n}\n.text-green[data-v-b795de40] {\n  color: #3ab336;\n}\n", ""]);
// Exports
module.exports = exports;
